export const IsFirefox = () => navigator.userAgent.indexOf('Firefox') !== -1;